import { Button, Dialog } from "@fluentui/react-northstar";
import { FormProvider } from "react-hook-form";
import DialogCreateExpenseContent from "./DialogCreateExpenseContent";
import { _api_add_note } from "../../../api";
import { _str_capitalize } from "../../../../../utils/functions";
import useCreateExpense from "../../../hooks/useCreateExpense";

const DialogCreateExpense = () => {
    const { dialog, form, mutations, t } = useCreateExpense();

    return (
        <FormProvider {...form.methods}>
            <form onSubmit={form.methods.handleSubmit(form.onSubmit)}>
                <Dialog
                    open={dialog.open}
                    header={t("dialogs.dialog_create_report.title")}
                    confirmButton={{
                        content: t(
                            "dialogs.dialog_create_report.confirm_button"
                        ),
                        flat: true,
                        loading: mutations.create_note.is_loading_adding_note,
                    }}
                    cancelButton={{
                        content: t(
                            "dialogs.dialog_create_report.cancel_button"
                        ),
                        flat: true,
                    }}
                    content={<DialogCreateExpenseContent />}
                    trigger={
                        <Button
                            content={t("home.button_text")}
                            onClick={dialog.openDialog}
                            primary
                            flat
                        />
                    }
                    onConfirm={dialog.onConfirm}
                    onCancel={dialog.onCancel}
                />
            </form>
        </FormProvider>
    );
};

export default DialogCreateExpense;
